import { render } from "./gsrst0105010204.vue?vue&type=template&id=60588d4a&scoped=true"
import script from "./gsrst0105010204.vue?vue&type=script&lang=js"
export * from "./gsrst0105010204.vue?vue&type=script&lang=js"

import "./gsrst0105010204.vue?vue&type=style&index=0&id=60588d4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60588d4a"]])

export default __exports__